module.exports = __webpack_public_path__ + "static/media/img-02.c027aba1.jpeg";